<template>
  <div>
    <div class="row dialog-selected">
      <div class="selected">已选</div>
      <div @click="onDelAllTag" class="delAllBtn">
          清空
        </div>
      <div class="row selected-tag">
        <div @click="onDelTag('industry', tag)" class="row industry-tag" v-for="tag in filterstTags.industry" :key="tag.id">
          <div>{{tag.name}}</div>
          <div class="del-img"></div>
        </div>
        <div @click="onDelTag('event', tag)" class="row industry-tag" v-for="tag in filterstTags.event" :key="tag.id">
          <div>{{tag.name}}</div>
          <div class="del-img"></div>
        </div>
        <div @click="onDelTag('emotional', tag)" class="row industry-tag" v-for="tag in filterstTags.emotional" :key="tag.id">
          <div>{{tag.name}}</div>
          <div class="del-img"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filterstTags: {
        industry: [],
        event: [],
        emotional: []
      },
      industry: [],
      event: [],
      emotional: []
    };
  },
  props: {
    filters: {
      type: Object
    }
  },
  methods: {
    onDelAllTag() {
      this.$emit('change', {
        industry: [],
        event: [],
        emotional: []
      });
    },
    onDelTag(type, tag) {
      if (type === 'industry') {
        this.filterstTags.industry.splice(this.filterstTags.industry.indexOf(tag), 1);
        this.changeEvent();
      } else if (type === 'event') {
        this.filterstTags.event.splice(this.filterstTags.event.indexOf(tag), 1);
        this.changeEvent();
      } else if (type === 'emotional') {
        this.filterstTags.emotional.splice(this.filterstTags.emotional.indexOf(tag), 1);
        this.changeEvent();
      }
    },
    changeEvent() {
      this.$emit('change', {
        industry: this.filterstTags.industry || [],
        event: this.filterstTags.event || [],
        emotional: this.filterstTags.emotional || []
      });
    }
  },
  watch: {
    'filters.industry'(newVal) {
      this.filterstTags.industry = newVal;
    },
    'filters.event'(newVal) {
      this.filterstTags.event = newVal;
    },
    'filters.emotional'(newVal) {
      this.filterstTags.emotional = newVal;
    }
  },
  mounted() {
    this.filterstTags.industry = this.filters.industry;
    this.filterstTags.event = this.filters.event;
    this.filterstTags.emotional = this.filters.emotional;
  }
};
</script>

<style lang="scss" scoped>
  .dialog-selected {
    padding: 16px 16px 6px;
    width: 100%;
    min-height: 56px;
    border-top: 1px solid #e8e8e8;
    color: #464d6c;
    font-size: 14px;
    font-weight: 500;
    background-color: #f7f8fc;
    position: relative;
    .selected {
      margin-top: 4px;
      width: 44px;
      font-weight: 600;
    }
    .selected-tag {
      flex: 1;
      flex-wrap: wrap;
      .industry-tag {
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 2px 8px;
        border-radius: 2px;
        border: solid 1px #e8e8e8;
        color: #747990;
        font-size: 14px;
        font-weight: 400;
      }
      .positive-tag {
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 2px 8px;
        border-radius: 4px;
        border: solid 1px #e8e8e8;
        color: #ff5b65;
        font-size: 14px;
      }
      .negative-tag {
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 2px 8px;
        border-radius: 4px;
        border: solid 1px #e8e8e8;
        color: #36c292;
        font-size: 14px;
      }
      .neutral-tag {
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 2px 8px;
        border-radius: 4px;
        border: solid 1px #e8e8e8;
        color: #747990;
        font-size: 14px;
      }
      .del-img {
        margin-left: 4px;
        margin-top: 2px;
        width: 16px;
        height: 16px;
        background: url("../../assets/img/del-hover.svg") no-repeat;
        background-size: cover;
        cursor: pointer;
        &:hover{
          background: url("../../assets/img/del-img.svg") no-repeat;
        }
      }
    }
       .delAllBtn {
        height: 24px;
        height: 24px;
        padding: 2px 12px;
        border-radius: 2px;
        background-color: #ffffff;
        font-size: 14px;
        color: #464d6c;
        position: absolute;
        right: 12px;
        top: 17px;
        font-weight: 400;
        cursor: pointer;
        &:hover{
          background-color: #45a8cc;
          color:#ffffff;
        }
      }
  }
</style>

